import cookie from '../lib/cookie'
import CCONSTANT from '../constant/cookie'

export const getDefaultServiceUrl = () => {
  return cookie(CCONSTANT.COOKIE_CO) == CCONSTANT.COOKIE_CO_IS_SDYXVIP
    ? 'https://mzw123.udesk.cn/im_client/?web_plugin_id=156661'
    : 'https://mzw123.udesk.cn/im_client/?web_plugin_id=145971'
}

export const toCustomerService = serviceUrl => {
  // 加载客服链接
  location.href = serviceUrl || getDefaultServiceUrl()
}
